var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"texticon"},[_c('van-icon',{attrs:{"name":_vm.icon,"size":_vm.iconSize,"color":_vm.color}}),_c('span',{style:({color:_vm.color, marginLeft: '4px', fontSize:_vm.textSize+'px'})},[_vm._v(_vm._s(_vm.text))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }